// extracted by mini-css-extract-plugin
var _1 = "SearchTypes-moduleSearchTypeInput__aktMn";
export { _1 as "SearchTypeInput" }
